import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Loader, VenueCardGrid } from '@resy/ui-kitchen';
import { PartySizeSelector } from '../../Nav/Selector';
import AmexShopSmallBuyoutTabs from './AmexShopSmallBuyoutTabs';
import { BUYOUT_STATE_THIS_WEEKS, DATE_TIMEFORMAT } from '../constants';
import currentTimeParserWithTimezone from '../currentTimeParserWithTimezone';
import AmexShopSmallEditorial from '../AmexShopSmallEditorial';
import './AmexShopSmallBuyout.scss';
import { postFinderList } from '../../../../../../ui-kitchen/src/api/api';
import { finder4Transform } from '../../../../../../ui-kitchen/src/api/resyApiTransformer';
import Logger from '../../../../../../ui-kitchen/src/utils/logger';

class AmexShopSmallBuyout extends React.Component {
  static propTypes = {
    $rootScope: PropTypes.shape({
      $digest: PropTypes.func,
    }).isRequired,
    loadNotifyModal: PropTypes.func.isRequired,
    $location: PropTypes.shape({
      search: PropTypes.func.isRequired,
    }).isRequired,
    buyoutConfig: PropTypes.shape({
      drop_time_for_display: PropTypes.string,
      notify_drop_message: PropTypes.string,
      deep_link_id: PropTypes.string.isRequired,
      party_size_label: PropTypes.string.isRequired,
      venues_error_text: PropTypes.string.isRequired,
    }).isRequired,
    Analytics: PropTypes.shape({ event: PropTypes.func.isRequired }).isRequired,
    taggingConfig: PropTypes.shape({
      buyout: PropTypes.shape({
        context: PropTypes.string,
        venue_card: PropTypes.shape({}),
        buyout_selector: PropTypes.shape({
          buyout_pill_click_event: PropTypes.string,
        }),
        selector: PropTypes.shape({
          party_size_change_event: PropTypes.string.isRequired,
          party_size_click_event: PropTypes.string.isRequired,
        }).isRequired,
      }),
      editorial: PropTypes.shape({}).isRequired,
    }).isRequired,
    baseRequestUrl: PropTypes.string.isRequired,
    editorialConfig: PropTypes.shape({
      title: PropTypes.string,
      subtitle: PropTypes.string,
      contents: PropTypes.shape({}),
    }).isRequired,
    handleTagging: PropTypes.func.isRequired,
    scrollTo: PropTypes.func.isRequired,
    toggleTerms: PropTypes.func.isRequired,
    showAuthModal: PropTypes.func.isRequired,
    favoriteVenueIds: PropTypes.arrayOf(PropTypes.number).isRequired,
    matchMedia: PropTypes.shape({
      xs: PropTypes.bool,
      sm: PropTypes.bool,
      md: PropTypes.bool,
      lg: PropTypes.bool,
      xl: PropTypes.bool,
    }).isRequired,
  }

    state = {
      venueList: [],
      loading: true,
      noDataToDisplay: false,
      selectedBuyoutDate: '',
      selectedSeats: '2',
      buyoutObjectState: {},
      displayPartySelector: false,
    };

    getVenueDetails = async (buyoutObjectTabs, seats) => {
      let buyoutObject = {};
      if (!buyoutObjectTabs) {
        const { buyoutObjectState } = this.state;
        buyoutObject = buyoutObjectState;
      } else {
        this.setState({ buyoutObjectState: buyoutObjectTabs });
        buyoutObject = buyoutObjectTabs;
      }
      this.setState({ loading: true });

      const {
        buyoutConfig,
      } = this.props;

      const { selectedSeats } = this.state;
      const {
        venue_ids: venueIds,
        selected_buyout_date: selectedBuyoutDate,
        drop_date_time: dropDateTime,
        drop_date_label: dropDateLabel,
        buyout_end_date: buyoutEndDate,
        buyoutState,
      } = buyoutObject;

      this.setState({ selectedBuyoutDate });

      const {
        drop_time_for_display: dropTimeForDisplay,
        notify_drop_message: notifyDropMessage,
      } = buyoutConfig;

      const notifyMessage = notifyDropMessage.replace('#date#', dropDateLabel);

      const venueIdArr = venueIds.map((item) => {
        if (item.venue_id) { return (item.venue_id); }
        return null;
      });

      this.setState({ venueIdArrLen: venueIdArr.length });

      const venueIdsWithoutPartySelector = [];
      const venueIdsWithPartySelector = [];

      if (buyoutState === BUYOUT_STATE_THIS_WEEKS) {
        venueIds.forEach((item) => {
          if (this.isShopSmallBuyoutEnabledPeriod(dropDateTime, buyoutEndDate, item.time_zone)) {
            venueIdsWithPartySelector.push(item.venue_id);
          } else {
            venueIdsWithoutPartySelector.push(item.venue_id);
          }
        });

        let venueResponseList = [];
        let venueResponseListWith = [];
        let venueResponseListWithout = [];

        if (venueIdsWithPartySelector.length > 0) {
          const params = {
            day: selectedBuyoutDate,
            party_size: seats || selectedSeats,
            venue_id: venueIdsWithPartySelector.toString(),
            resy_token: undefined,
            lat: 0,
            long: 0,
          };
          venueResponseListWith = await this.fetchVenuesAPI(params);
        }

        if (venueIdsWithoutPartySelector.length > 0) {
          const params = {
            day: selectedBuyoutDate,
            party_size: '2',
            venue_id: venueIdsWithoutPartySelector.toString(),
            resy_token: undefined,
            lat: 0,
            long: 0,
          };
          venueResponseListWithout = await this.fetchVenuesAPI(params);
        }

        venueResponseList = venueResponseListWith.concat(venueResponseListWithout);

        if (venueResponseList) {
          this.transformResponse(venueResponseList, venueIds, buyoutState,
            dropDateTime, buyoutEndDate, notifyMessage, dropTimeForDisplay);
        }
      } else {
        const params = {
          day: selectedBuyoutDate,
          party_size: seats || selectedSeats,
          venue_id: venueIdArr.toString(),
          resy_token: undefined,
          lat: 0,
          long: 0,
        };

        const venueResponseList = await this.fetchVenuesAPI(params);
        this.transformResponse(venueResponseList, venueIds, buyoutState, dropDateTime,
          buyoutEndDate, notifyMessage, dropTimeForDisplay);
      }
    }

     isShopSmallBuyoutEnabledPeriod = (dropDateTime, buyoutEndDate, shopSmallTimezone) => {
       let isEnabled = false;

       const parseCurrentDateinSpecificTimeZone = currentTimeParserWithTimezone(shopSmallTimezone);

       const buyoutEndDateMoment = moment(buyoutEndDate, DATE_TIMEFORMAT);
       const dropDateTimeMoment = moment(dropDateTime, DATE_TIMEFORMAT);

       if (
         (parseCurrentDateinSpecificTimeZone.isSameOrAfter(dropDateTimeMoment))
       && (parseCurrentDateinSpecificTimeZone.isSameOrBefore(buyoutEndDateMoment))
       ) {
         isEnabled = true;
       }

       return isEnabled;
     };

     transformResponse = (venueResponseList, venueIds, buyoutState, dropDateTime,
       buyoutEndDate, notifyMessage, dropTimeForDisplay) => {
       venueResponseList = venueResponseList.map((item) => {
         const venuArrObj = venueIds?.find((o) => Number(o.venue_id) === item.venue.id);
         item.shopSmallBuyoutState = buyoutState;
         item.shopSmallIndex = venuArrObj.id;
         const buyoutPeriodEnabled = this.isShopSmallBuyoutEnabledPeriod(dropDateTime, buyoutEndDate, venuArrObj.time_zone);
         item.shopSmallBuyoutEnabled = buyoutPeriodEnabled;
         if (buyoutPeriodEnabled && (buyoutState === BUYOUT_STATE_THIS_WEEKS)) {
           this.setState({ displayPartySelector: true });
         }
         item.shopSmallNotifyDropMessage = `${notifyMessage.replace('#localtime#', dropTimeForDisplay)} ${venuArrObj.time_zone}`;
         return item;
       });

       const venueResponseListSorted = venueResponseList.sort((a, b) => a.shopSmallIndex
       - b.shopSmallIndex);

       if (venueResponseListSorted) {
         this.setState({ venueList: venueResponseListSorted, loading: false, noDataToDisplay: false });
       }
     }

    fetchVenuesAPI = async (params) => {
      let venueResponseList = [];
      let apiResponse = null;

      try {
        const response = await postFinderList(params);
        apiResponse = finder4Transform(response);
        venueResponseList = apiResponse?.results.venues || [];
      } catch (error) {
        if (error.status === 400) {
          Logger.error('ERROR [AmexSmallShopBuyout] -  Error API Response -- ', error.data?.data);
          this.setState({ loading: false, venueList: [] });
        }
      }
      return venueResponseList;
    }

    loadingComponent = () => (<div><Loader className="AmexSmallShopBuyout__loader" /></div>);

    onPartySizeChange = async ({ party_size: seats }) => {
      const { selectedSeats } = this.state;
      const {
        Analytics, taggingConfig: {
          buyout: {
            context: contextProps = 'Shop Small Page',
            selector:
              {
                party_size_change_event: partySizeChangeEvent,
              },
          },
        },
      } = this.props;
      this.getVenueDetails(undefined, seats);
      const previousQuantity = selectedSeats;
      if (!previousQuantity) return;

      if (String(previousQuantity) !== seats) {
        await Analytics.event(partySizeChangeEvent, {
          Context: contextProps,
          'party size': seats,
        });
      }

      this.setState({ selectedSeats: seats });
    }

    onPartySizeClick = () => {
      const {
        buyoutObjectState: { code: selectedBuyoutCode },
      } = this.state;

      const {
        Analytics, taggingConfig: {
          buyout: {
            context: contextProps = 'Shop Small Page',
            selector:
              {
                party_size_click_event: partySizeClickEvent,
              },
          },
        },
      } = this.props;
      Analytics.event(partySizeClickEvent, {
        city: selectedBuyoutCode,
        Context: contextProps,
      });
    }

    renderPartySelector = () => {
      const { selectedSeats } = this.state;
      const {
        buyoutConfig: {
          party_size_label: partySizeLabel,
        },
      } = this.props;
      return (
        <div className="AmexSmallShopBuyout__panel">
          <div className="AmexSmallShopBuyout__selector">
            <p className="AmexSmallShopBuyout__selector-info">{partySizeLabel}</p>
            <PartySizeSelector
              onClick={this.onPartySizeClick}
              onChange={this.onPartySizeChange}
              quantitySelected={selectedSeats}
              showChevron={false}
              shopSmallMaxGuest={6}
            />
          </div>
        </div>

      );
    }

    renderVenueGrid = () => {
      const {
        loadNotifyModal,
        $rootScope,
        Analytics: { event },
        buyoutConfig: {
          venues_error_text: venuesErrorText,
        },
        taggingConfig: {
          buyout: {
            venue_card: venueCardConfig,
          },
        },
        showAuthModal, favoriteVenueIds,
        matchMedia,
      } = this.props;

      const { selectedSeats, venueIdArrLen } = this.state;
      const {
        venueList, loading, noDataToDisplay, selectedBuyoutDate, buyoutObjectState,
      } = this.state;

      const {
        buyoutState,
      } = buyoutObjectState;

      let renderComp = '';
      if (loading === true) {
        renderComp = this.loadingComponent();
      } else if (noDataToDisplay === true) {
        renderComp = '';
      } else if (loading === false && venueList) {
        let displayErrorTextRender = '';

        if (venueIdArrLen > venueList.length && (buyoutState === BUYOUT_STATE_THIS_WEEKS)) {
          displayErrorTextRender = (
            <>
              <p className="AmexSmallShopBuyout__content--dynamic-error">
                {venuesErrorText}
              </p>
            </>
          );
        }

        renderComp = (
          <>

            {displayErrorTextRender}
            <div className={`AmexSmallShopBuyout AmexSmallShopBuyout__venuegrid__body card-${venueList.length}-list`}>
              <VenueCardGrid
                $rootScope={$rootScope}
                userIsGda={false}
                event={event}
                list="Amex Shop Small"
                loadNotifyModal={loadNotifyModal}
                restaurants={venueList}
                selectedDate={selectedBuyoutDate}
                selectedSeats={selectedSeats}
                limit={venueList.length}
                isGda={false}
                isAmexShopSmallBuyoutFlag
                isAmexShopSmallFlag
                shopSmallBuyoutVenueCardEvents={venueCardConfig}
                showAuthModal={showAuthModal}
                favoriteVenueIds={favoriteVenueIds}
                matchMedia={matchMedia}
              />
            </div>
          </>
        );
      }

      return renderComp;
    }

    renderBuyoutTabs =() => {
      const {
        buyoutConfig, Analytics, taggingConfig, scrollTo, toggleTerms,
      } = this.props;
      return (
        <AmexShopSmallBuyoutTabs
          buyoutConfig={buyoutConfig}
          getVenueDetails={this.getVenueDetails}
          Analytics={Analytics}
          taggingConfig={taggingConfig?.buyout}
          scrollTo={scrollTo}
          toggleTerms={toggleTerms}
        />
      );
    }

  renderEditorials = () => {
    const {
      baseRequestUrl,
      editorialConfig,
      handleTagging,
      taggingConfig,
    } = this.props;
    const { buyoutObjectState: { code } } = this.state;
    const hasEditorials = editorialConfig?.contents && editorialConfig?.contents[code];
    return hasEditorials && (
      <AmexShopSmallEditorial
        baseRequestUrl={baseRequestUrl}
        selectedCode={code}
        editorialConfig={editorialConfig}
        handleTagging={handleTagging}
        tagConfig={taggingConfig}
        type="buyout"
      />
    );
  }

  render() {
    const {
      displayPartySelector,
      buyoutObjectState: { buyoutState },
    } = this.state;

    const {
      buyoutConfig: { deep_link_id: hashId },
    } = this.props;

    return (
      <section className="AmexSmallShopBuyout" id={hashId}>
        <div className="container">
          <div className="AmexSmallShopBuyout__wrapper">
            {this.renderBuyoutTabs()}
            {displayPartySelector && (buyoutState === BUYOUT_STATE_THIS_WEEKS) && this.renderPartySelector()}
            {this.renderVenueGrid()}
            {this.renderEditorials()}
          </div>
        </div>
      </section>
    );
  }
}

export default AmexShopSmallBuyout;
